import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AssetHeader = ({ asset, onEdit, onPrint, onDelete, isEditing, onSave, onCancel }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'bg-success text-success-foreground';
      case 'spare':
        return 'bg-warning text-warning-foreground';
      case 'repair':
        return 'bg-error text-error-foreground';
      case 'retired':
        return 'bg-secondary text-secondary-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6 shadow-subtle">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Package" size={24} color="white" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-foreground">
                {asset?.name || asset?.asset_id}
              </h1>
              <p className="text-muted-foreground">
                Asset ID: {asset?.asset_id}
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(asset?.status)}`}>
              {asset?.status}
            </span>
            <span className="text-sm text-muted-foreground">
             Last updated: {
                asset?.last_updated
                  ? new Date(asset.last_updated).toLocaleDateString()
                  : 'N/A'
              }
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          {isEditing ? (
            <>
              <Button variant="outline" onClick={onCancel} iconName="X" iconPosition="left">
                Cancel
              </Button>
              <Button variant="default" onClick={onSave} iconName="Save" iconPosition="left">
                Save Changes
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="icon" onClick={onPrint} title="Print Asset Details">
                <Icon name="Printer" size={18} />
              </Button>
              <Button variant="outline" onClick={onEdit} iconName="Edit" iconPosition="left">
                Edit
              </Button>
              <Button variant="destructive" onClick={onDelete} iconName="Trash2" iconPosition="left">
                Delete
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssetHeader;